import UntrackedModel from "../../../common/models/untracked/untrackedModel";
import BookmarkLink from "./bookmarkLink";
import {RelationType} from "../../../common/models/relationType";
import IBookmarkFolder from "../interfaces/bookmarkFolderInterface";
import {IBookmarkLink} from "../interfaces/bookmarkLinkInterface";
import SortableHelper from "../../../common/helpers/sortableHelper";

export default class BookmarkFolder extends UntrackedModel implements IBookmarkFolder {
  name: string = '';
  bookmark_links: Array<BookmarkLink> = [];
  sort_order: number;

  get EMBEDDED_MODELS(): {[key: string]: {type: any, relationType: RelationType}} {
    return {
      'bookmark_links': {type: BookmarkLink, relationType: RelationType.array},
    };
  }

  get sortedBookmarkLinks(): Array<BookmarkLink> {
    return SortableHelper.getSorted(this.bookmark_links);
  }

  set sortedBookmarkLinks(desiredOrderedArray) {
    SortableHelper.setSorted(desiredOrderedArray);
  }
}
